import { includes } from 'lodash';
import { BAD_RECORD_NAMES } from 'src/utils/constants/badRecordNames';
// import { EmptyText } from 'src/utils/constants/config';

export const handleBadRecordName = (text?: string | null) => {
  if (includes(BAD_RECORD_NAMES, text)) return null;
  return text;
};
